<script>
  import * as _ from "lodash";
  import ProductListRow from "@retailer/svelte/ListBuilder/Components/ProductPicker/ProductListRow.svelte";

  export let list;
  export let placeholderProduct;
  export let products;
  export let onAddProductToList;
  export let onRemoveProductFromList;
  let filtered = [];

  function isIncludedInList(product) {
    return (
      list.quick_order_list_products.find(
        qolp =>
          _.get(qolp, "product.product_id") === product.id &&
          _.get(qolp, "product.inventory_id") === product.inventory_id,
      ) != null
    );
  }

  function filteredProducts() {
    const filtered = {};
    if (!products) {
      return [];
    }
    products.forEach(product => {
      filtered[product.id] = product;
    });
    return Object.values(filtered);
  }
  $: {
    products = products;
    list = list;
    filtered = filteredProducts();
  }
</script>

<ul class="product-picker__product-list">
  {#each filtered as product}
    <li key={product.id}>
      <ProductListRow
        {placeholderProduct}
        isAlreadyIncludedInList={isIncludedInList(product)}
        {product}
        {onAddProductToList}
        {onRemoveProductFromList}
      />
    </li>
  {/each}
</ul>
